import React, {createContext, ReactNode, useContext, useState} from 'react'

interface UIGameReplayContextType {
    isReplay: boolean
    setIsReplay: (isReplay: boolean) => void
}

export const UIGameReplayContext = createContext<UIGameReplayContextType | undefined>(undefined)

export const useUIGameReplayContext = () => {
    const context = useContext(UIGameReplayContext)
    if(!context) {
        throw new Error('useUIGameReplayContext must be used within a UIGameReplayProvider')
    }
    return context
}

interface UIGameReplayProviderProps {
    isReplay: boolean
    children: ReactNode
}

export const UIGameReplayProvider = ({
    isReplay: defaultIsReplay,
    children,
}: UIGameReplayProviderProps) => {
    const [isReplay, setIsReplay] = useState(defaultIsReplay)

    return <UIGameReplayContext.Provider value={{
        isReplay: isReplay,
        setIsReplay: setIsReplay,
    }}>
        {children}
    </UIGameReplayContext.Provider>
}
